"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPayloadMessageType = void 0;
/**
 * full check for validity not expected to work with anything pre 2022
 * @param x
 * @returns
 */
const isPayloadMessageType = (x) => {
    return isPayloadMessageStateReportedMetdataType(x?.state ?? {});
};
exports.isPayloadMessageType = isPayloadMessageType;
const isPayloadMessageStateReportedMetdataType = (x) => {
    return isMetadata(x?.reported?.meta);
};
const isMetadata = (x) => {
    return x?.timestamp !== undefined && x?.deviceId !== undefined;
};
// export type { PayloadMessageType };
